import React from 'react'
import { AlertView } from '../Components/Views/Alert/AlertView'
import { controllers } from '../Controllers/Controllers'
import { MenuHouper } from '../Views/MenuView/MenuHouperView'
import { MenuItemsView } from '../Views/MenuView/MenuItemsView'
import { MainLoader } from './MainLoader'
import { AuthModalWrapper } from '../Views/Modals/AuthModalWrapper'
import { CopyModalView } from '../Views/ModalViews/Copy/CopyModal'

class Helpers extends React.Component {
    render(){
        const { menu, load, modals } = controllers()
        const { menuHouper, menuItems } = menu
        const { authModal, copy } = modals
        // main navigation
        return <div className="helpers">
            <div className="helpers-box">
                <AlertView/>
                <MenuHouper 
                    ref={menuHouper.set} 
                    controller={menuHouper}
                    RightComponent={<MenuItemsView ref={menuItems.set} controller={menuItems}/>}
                />
                <MainLoader ref={load.set} controller={load}/>
                <CopyModalView ref={copy.set} controller={copy}/>
                {/* <AuthModalWrapper ref={authModal.set} controller={authModal}/> */}
                
            </div>
        </div>
    }
}

export { Helpers }